// extracted by mini-css-extract-plugin
export default {"tableHead":"invited_tableHead__2x8o5","active":"invited_active__rBRrv","sentDetails":"invited_sentDetails__J+MH7"};